import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Auction, AuctionIgnored} from "domain-models"
import Form from "mixins/form"
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React from "react"
import {fetchAuctions, SubjectType} from 'redux/actions'
import {AuctionsState} from "../../../../redux/reducers/AuctionReducer"
import {GlobalState} from "../../../../state"
import {connect} from "react-redux"
import Trans from '../../../../components/Trans'

type IgnoreButtonProps = {
  close: () => void
  auction: Auction
  small?: boolean
  auctions: AuctionsState
  subjectType: SubjectType
}

type IgnoreButtonState = {
  form: FormType
  ignored: AuctionIgnored | null
}

class IgnoreButton extends React.Component<IgnoreButtonProps, IgnoreButtonState> {
  private form: FormType = new Form({})

  constructor(props: IgnoreButtonProps) {
    super(props)
    this.state = {
      form: this.form,
      ignored: this.props.auction.ignored
    }
  };

  ignore = async () => {
    await Http.post('auctions/' + this.props.auction.Id + '/ignore', {state: this, form: this.state.form})
    await fetchAuctions(this.props.auctions.filter, this.props.subjectType)
    this.props.close && this.props.close()
  }

  unIgnore = async () => {
    if (!this.props.auction.ignored) {
      return
    }
    await Http.delete('auctions/' + this.props.auction.Id + '/ignore/' + this.props.auction.ignored.id, {
      state: this,
      form: this.state.form
    })
    await fetchAuctions(this.props.auctions.filter, this.props.subjectType)
  }

  render() {
    const {watched_by_user, round} = this.props.auction
    const {busy} = this.state.form

    return ((watched_by_user || round.bid) && !this.state.ignored) ? null : (
      <button title="Auktion Ignorieren" className={'bg-gray-100 w-full rounded hover:bg-gray-200 text-gray-500 px-3 py-1 font-semibold whitespace-no-wrap shadow text-base ' + (busy ? ' cursor-not-allowed opacity-75' : '')} disabled={busy} onClick={this.state.ignored ? this.unIgnore : this.ignore}>
        {busy ?
          <Icon icon="spinner" spin={true}/>
          :
          <Icon icon="eye-slash"/>
        }

        {this.props.small ? null : this.state.ignored ? <span> <Trans>Nicht mehr Ignorieren</Trans></span> :
          <span> <Trans>Auktion ignorieren</Trans></span>}
      </button>
    )
  }
}

export default connect((state: GlobalState) => ({
  auctions: state.auctions,
  subjectType: state.app.subjectType
}))(IgnoreButton)
